<template>
    <button v-on:click="crashInfoButton" class="crash-history-element" v-bind:class="{
        'element-high': crashGetOutcome >= 10,
        'element-mid': crashGetOutcome < 10 && crashGetOutcome >= 2
    }">
        <div class="element-inner">
            <span>{{crashGetOutcome}}x</span>
        </div>
    </button>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'CrashHistoryElement',
        props: [
            'game'
        ],
        methods: {
            ...mapActions([
                'modalsSetData', 
                'modalsSetShow'
            ]),
            crashInfoButton() {
                this.modalsSetData({ game: this.game });
                this.modalsSetShow('FairGame');
            }
        },
        computed: {
            crashGetOutcome() {
                return parseFloat(this.game.outcome / 100).toFixed(2);
            }
        }
    }
</script>

<style scoped>
    button.crash-history-element {
        width: 72px;
        height: 38px;
        position: relative;
        flex-shrink: 0;
        margin-right: 8px;
        padding: 0;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
    }

    button.crash-history-element:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
    }

    button.crash-history-element:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    button.crash-history-element:last-of-type {
        margin-right: 0;
    }

    /* Base: modern glass-like purple – deep indigo (#3D2871) */
    button.crash-history-element .element-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        background: #3D2871;
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    button.crash-history-element .element-inner span {
        font-size: 13px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
        letter-spacing: 0.03em;
    }

    /* Crashed (< 2x): neutral – muted white */
    button.crash-history-element:not(.element-mid):not(.element-high) .element-inner {
        background: rgba(61, 40, 113, 0.7);
        border-color: rgba(255, 255, 255, 0.08);
    }

    button.crash-history-element:not(.element-mid):not(.element-high) .element-inner span {
        color: rgba(255, 255, 255, 0.7);
    }

    /* Won (2x – 10x): subtle green accent */
    button.crash-history-element.element-mid .element-inner {
        background: linear-gradient(135deg, #3D2871 0%, #45307a 100%);
        border-color: rgba(0, 255, 194, 0.35);
    }

    button.crash-history-element.element-mid .element-inner span {
        color: var(--accent-green);
    }

    /* High (10x+): subtle gold accent */
    button.crash-history-element.element-high .element-inner {
        background: linear-gradient(135deg, #3D2871 0%, #4a3565 100%);
        border-color: rgba(236, 173, 70, 0.4);
    }

    button.crash-history-element.element-high .element-inner span {
        color: #f5d078;
    }

    @media only screen and (max-width: 950px) {
        button.crash-history-element {
            width: 62px;
            height: 34px;
            margin-right: 6px;
        }

        button.crash-history-element .element-inner {
            border-radius: 8px;
        }

        button.crash-history-element .element-inner span {
            font-size: 12px;
            font-weight: 600;
        }

        button.crash-history-element:hover {
            transform: none;
        }

        button.crash-history-element:active {
            opacity: 0.9;
        }
    }
</style>
